import * as React from 'react'

import type { NavigationRoutesFn } from 'modules/core/lib/react-router'

const DeleteCustomTablePage = React.lazy(
  () => import('modules/custom_resources/pages/DeleteCustomTablePage')
)
const EditCustomTablePage = React.lazy(
  () => import('modules/custom_resources/pages/EditCustomTablePage')
)
const NewCustomTablePage = React.lazy(
  () => import('modules/custom_resources/pages/NewCustomTablePage')
)
const RootPage = React.lazy(() => import('modules/custom_resources/pages/employees/RootPage'))

const employeesRoutes: NavigationRoutesFn = (navigation) => {
  return [
    {
      path: navigation.employees.id.customTables.path,
      element: <RootPage />,
      children: [
        {
          path: navigation.employees.id.customTables.schemaIdNew.path,
          element: <NewCustomTablePage />,
        },
        {
          path: navigation.employees.id.customTables.schemaIdValuesValueIdEdit.path,
          element: <EditCustomTablePage />,
        },
        {
          path: navigation.employees.id.customTables.schemaIdValuesValueIdDelete.path,
          element: <DeleteCustomTablePage />,
        },
      ],
    },
  ]
}

export default employeesRoutes
